export default __webpack_public_path__ + "images/shipnexa_rateCard.svg";